export type ToolModule = {
  render: (root: HTMLElement) => void | Promise<void>;
};

export type ToolMeta = {
  id: string;
  title: string;
  description: string;
  category: 'pages' | 'optimize' | 'convert' | 'edit' | 'security';
  icon: string;
  load: () => Promise<ToolModule>;
  beta?: boolean;
};

export const tools: ToolMeta[] = [
  {
    id: 'compress',
    title: 'Сжать PDF',
    description: 'JPEG-сжатие страниц для отправки и архива.',
    category: 'optimize',
    icon: '↓',
    load: () => import('./compress/compress'),
  },
  {
    id: 'organize',
    title: 'Организовать PDF',
    description: 'Переставьте, поверните, удалите, извлеките и добавьте страницы.',
    category: 'pages',
    icon: '▤',
    load: () => import('./organize/organize'),
  },
  {
    id: 'merge',
    title: 'Объединить PDF',
    description: 'Склейте несколько документов в один файл.',
    category: 'pages',
    icon: '+',
    load: () => import('./merge/merge'),
  },
  {
    id: 'pdf-to-docx',
    title: 'PDF → Word',
    description: 'DOCX из текстового PDF: абзацы, заголовки, жирный/курсив.',
    category: 'convert',
    icon: 'W',
    load: () => import('./pdf-to-docx/pdf-to-docx'),
  },
  {
    id: 'sign',
    title: 'Подписать PDF',
    description: 'Добавьте подпись, текст, дату или галочку поверх документа.',
    category: 'edit',
    icon: 'S',
    load: () => import('./sign/sign'),
  },
  {
    id: 'jpg-to-pdf',
    title: 'JPG / PNG → PDF',
    description: 'Соберите PDF из изображений в нужном порядке.',
    category: 'convert',
    icon: '▧',
    load: () => import('./jpg-to-pdf/jpg-to-pdf'),
  },
  {
    id: 'edit',
    title: 'Редактор PDF',
    description: 'Аннотации, картинки и правка существующего текста.',
    category: 'edit',
    icon: '✎',
    load: () => import('./edit/edit'),
  },
  {
    id: 'split',
    title: 'Разделить PDF',
    description: 'Извлеките или разрежьте страницы PDF.',
    category: 'pages',
    icon: '⌁',
    load: () => import('./split/split'),
  },
  {
    id: 'rotate',
    title: 'Повернуть страницы',
    description: 'Поверните выбранные страницы на 90/180/270°.',
    category: 'pages',
    icon: '↻',
    load: () => import('./rotate/rotate'),
  },
  {
    id: 'pdf-to-jpg',
    title: 'PDF → JPG',
    description: 'Сохраните страницы PDF как изображения.',
    category: 'convert',
    icon: '▣',
    load: () => import('./pdf-to-jpg/pdf-to-jpg'),
  },
  {
    id: 'pdf-to-txt',
    title: 'PDF → текст',
    description: 'Извлеките текстовый слой из PDF.',
    category: 'convert',
    icon: 'T',
    load: () => import('./pdf-to-txt/pdf-to-txt'),
  },
  {
    id: 'docx-to-pdf',
    title: 'Word → PDF',
    description: 'Конвертируйте .docx в PDF (черновая).',
    category: 'convert',
    icon: 'D',
    load: () => import('./docx-to-pdf/docx-to-pdf'),
  },
  {
    id: 'xlsx-to-pdf',
    title: 'Excel → PDF',
    description: 'Конвертируйте .xlsx в PDF с таблицами.',
    category: 'convert',
    icon: 'X',
    load: () => import('./xlsx-to-pdf/xlsx-to-pdf'),
  },
  {
    id: 'csv-to-pdf',
    title: 'CSV → PDF',
    description: 'Соберите CSV в красивый PDF-отчёт.',
    category: 'convert',
    icon: 'C',
    load: () => import('./csv-to-pdf/csv-to-pdf'),
  },
];

export const categoryLabels: Record<ToolMeta['category'], string> = {
  pages: 'Страницы',
  optimize: 'Сжатие',
  convert: 'Конвертация',
  edit: 'Редактирование',
  security: 'Защита',
};

export function findTool(id: string): ToolMeta | undefined {
  return tools.find((t) => t.id === id);
}
